var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let MessageInput = class MessageInput extends LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
    }
    handleInput(e) {
        const target = e.target;
        this.value = target.value;
    }
    handleKeyDown(e) {
        if (e.key === 'Enter' && this.value.trim()) {
            this.sendMessage();
        }
    }
    sendMessage() {
        if (!this.value.trim())
            return;
        this.dispatchEvent(new CustomEvent('new-message', {
            detail: this.value,
            bubbles: true,
            composed: true,
        }));
        this.value = '';
    }
    render() {
        return html `
      <basic-card>
        <div class="message-input">
          <input
            class="message-input__field"
            type="text"
            .value=${this.value}
            placeholder=${this.placeholder || msg('Type a message...', { id: 'messageInput.placeholder', desc: 'Message input placeholder' })}
            @input=${this.handleInput}
            @keydown=${this.handleKeyDown}
          />
          <simple-button
            label=${this.buttonLabel || msg('Send', { id: 'messageInput.send', desc: 'Send button label' })}
            variant="primary"
            size="medium"
            @button-click=${this.sendMessage}
          ></simple-button>
        </div>
      </basic-card>
    `;
    }
};
MessageInput.styles = css `
    .message-input {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    .message-input__field {
      flex: 1;
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 14px;
      box-sizing: border-box;
      transition: border 0.3s, box-shadow 0.3s;
    }

    .message-input__field:focus {
      border-color: #0078d4;
      box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.2);
      outline: none;
    }
  `;
__decorate([
    property({ type: String })
], MessageInput.prototype, "placeholder", void 0);
__decorate([
    property({ type: String })
], MessageInput.prototype, "buttonLabel", void 0);
__decorate([
    state()
], MessageInput.prototype, "value", void 0);
MessageInput = __decorate([
    localized(),
    customElement('message-input')
], MessageInput);
export { MessageInput };
//# sourceMappingURL=MessageInput.js.map